// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class AgentsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicAgents';
        this.Server = this.props.context.getState().server.publicAgents;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'phone'];

        const defaultHead = [
            {
                id: 'name',
                label: 'name',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'phone',
                label: 'phone',
                alignRight: false,
                cell: 'Phone',
                displayGrid: true
            },
            {
                id: 'description',
                label: 'description',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'balances',
                label: 'balances',
                alignRight: false,
                cell: 'Balance',
                defaultCurrencies: ['AUD', 'EUR', 'KZT', 'RUB', 'UAH', 'USD'],
                displayGrid: true,
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated',
            },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    renderCustomMenuItems() {
        return [
            <MenuItem key="showDetails" onClick={(event) => this.handleShowDialogDetails(event)}>
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];
    }
}
